export default function DownloadIcon({ className="", onClick=null }) {
  return (
    <>
      <svg className={className} onClick={onClick} viewBox="0 0 13 18" xmlns="http://www.w3.org/2000/svg">
        <path d="m10.367 6.4138c0.3406-0.33897 0.8989-0.33897 1.2395 0 0.172 0.17124 0.2563 0.39489 0.2563 0.61854s-0.0843 0.44731-0.2563 0.61854l-3.9501 3.9314-1.243 1.237-1.2394-1.237-3.9536-3.9314c-0.34058-0.34247-0.34058-0.89461 0-1.2371 0.3441-0.33897 0.89886-0.33897 1.243 0l3.9536 3.9314 3.9501-3.9314z"/>
        <path d="m7.4766 1.75c0-0.55228-0.44771-1-1-1-0.55228 0-1 0.44772-1 1h2zm0 9.9217v-9.9217h-2v9.9217h2z"/>
        <path d="m1.5158 13.509v2.4909c0 0.5523 0.44772 1 1 1h7.9217c0.5523 0 1-0.4477 1-1v-2.4909" strokeLinecap="round" strokeWidth="2"/>
      </svg>
    </>
  );
}